import FeaturesContainer from './FeaturesContainer'

const PlaceAlerts = ({ history }) => {
    return <FeaturesContainer history={history} pageName={'place-alerts'} nextUrl={'check-in'} pageEvent={'onboardingPlaceAlerts'} clickEvent={'onboardingPlaceAlertsSubmitted'} />
};

export default PlaceAlerts
